module.exports = __webpack_public_path__ + "static/img/图层1.de63a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/图层1.png
// module id = o5bz
// module chunks = 192